import { ButtonHeader } from '../../../Header/Style';
import SVG from '../../../SVG';
import { Control, ControlContainer } from '../../../Controls/styled';
import {
  getFilterColumn,
  getSortColumn,
  setFilterColumn,
  setSortColumn,
} from '../../../../store/utils';
import Table from '../../../Table';
import useExportsController from '../useExportsController';
import { useAbility } from '../../../Hooks/useAbility';
import { useState } from 'react';

const useLogisticsController = () => {
  const {
    getInvoice,
    setInvoice,
    validateForm,
    setModal,
    getFormMessage,
    currentRoute,
    enqueueSnackbar,
    deleteLogistics: deleteLogisticsAction,
    autocompleteLogistic,
    filterLogistic,
    createLogistic,
    updateLogistic,
    deleteLogisticOrigins: deleteLogisticOriginsAction,
    autocompleteLogisticOrigin,
    filterLogisticOrigin,
    createLogisticOrigin,
    updateLogisticOrigin,
    filterSelectCompanies,
    selectCompanies,
    setCompanyFilterField,
    filterGroupLogistic,
    groups,
    user,
    selectedGroupId,
  } = useExportsController();
  const { Can } = useAbility();

  const logistics = getInvoice('filters.logistics.data.data');
  const checkLogisticIds = getInvoice('selecteds.logistics');
  const reportLogistic = getInvoice('filters.logistics.data.report');

  const logisticOrigins = getInvoice('filters.logisticOrigins.data.data');
  const checkLogisticOriginIds = getInvoice('selecteds.logisticOrigins');
  const reportLogisticOrigin = getInvoice('filters.logisticOrigins.data.report');

  const setCheckLogisticIds = (selectedLogisticIds: number[]) =>
    setInvoice('selecteds.logistics', selectedLogisticIds);

  const setCheckLogisticOriginIds = (selectedLogisticOriginIds: number[]) =>
    setInvoice('selecteds.logisticOrigins', selectedLogisticOriginIds);

  const allLogisticChecks = logistics.every(({ id }) => checkLogisticIds.includes(id));

  const allLogisticOriginChecks = logisticOrigins.every(({ id }) => checkLogisticOriginIds.includes(id));

  const logisticCheckAll = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    if (checked) {
      setCheckLogisticIds(logistics.map(({ id }) => id));
    } else {
      setCheckLogisticIds([]);
    }
  };

  const logisticOriginCheckAll = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    if (checked) {
      setCheckLogisticOriginIds(logisticOrigins.map(({ id }) => id));
    } else {
      setCheckLogisticOriginIds([]);
    }
  };

  const checkLogisticId = (logisticId: number) => {
    const newcheckIds = checkLogisticIds.includes(logisticId)
      ? checkLogisticIds.filter((id) => id !== logisticId)
      : [...checkLogisticIds, logisticId];
    setCheckLogisticIds(newcheckIds);
  };

  const checkLogisticOriginId = (logisticOriginId: number) => {
    const newcheckIds = checkLogisticOriginIds.includes(logisticOriginId)
      ? checkLogisticOriginIds.filter((id) => id !== logisticOriginId)
      : [...checkLogisticOriginIds, logisticOriginId];
    setCheckLogisticOriginIds(newcheckIds);
  };

  const deleteLogisticLoadings = getInvoice('loadings.deleteLogistics');

  const deleteLogisticOriginLoadings = getInvoice('loadings.deleteLogisticOrigins');

  const setDeleteLogisticLoadings = (setDeleteLogisticLoadings: boolean[]) =>
    setInvoice('loadings.deleteLogistics', setDeleteLogisticLoadings);

  const setDeleteLogisticOriginLoadings = (setDeleteLogisticOriginLoadings: boolean[]) =>
    setInvoice('loadings.deleteLogisticOrigins', setDeleteLogisticOriginLoadings);

  const deleteLogistics = (logisticIds: number[] = checkLogisticIds) =>
    new Promise((resolve, reject) => {
      const length = logisticIds.length;

      const indexes = logisticIds.map((logisticId) =>
        logistics.findIndex(({ id }) => logisticId === id),
      );

      setDeleteLogisticLoadings(
        logistics.map((_, i) =>
          indexes.includes(i) ? true : deleteLogisticLoadings[i],
        ),
      );

      deleteLogisticsAction(logisticIds)
        .then(() => {
          const newCheckIds = checkLogisticIds.filter((id) => !logisticIds.includes(id));
          setCheckLogisticIds(newCheckIds);
          filterLogistic();
          resolve(true);
          enqueueSnackbar(
            length === 1
              ? 'A logística foi excluída com sucesso'
              : 'As logísticas foram excluídas com sucesso',
            {
              variant: 'success',
            },
          );
        })
        .catch(() => {
          reject(false);
          enqueueSnackbar(
            length === 1
              ? 'Houve uma falha ao excluir a logística'
              : 'Houve uma falha ao excluir as logísticas',
            {
              variant: 'error',
            },
          );
        })
        .finally(() => {
          setDeleteLogisticLoadings(
            logistics.map((_, i) =>
              indexes.includes(i) ? false : deleteLogisticLoadings[i],
            ),
          );
        });
    });


  const deleteLogisticOrigins = (logisticOriginIds: number[] = checkLogisticOriginIds) =>
    new Promise((resolve, reject) => {
      const length = logisticOriginIds.length;

      const indexes = logisticOriginIds.map((logisticOriginId) =>
        logisticOrigins.findIndex(({ id }) => logisticOriginId === id),
      );

      setDeleteLogisticOriginLoadings(
        logisticOrigins.map((_, i) =>
          indexes.includes(i) ? true : deleteLogisticOriginLoadings[i],
        ),
      );

      deleteLogisticOriginsAction(logisticOriginIds)
        .then(() => {
          const newCheckIds = checkLogisticOriginIds.filter((id) => !logisticOriginIds.includes(id));
          setCheckLogisticOriginIds(newCheckIds);
          filterLogisticOrigin();
          resolve(true);
          enqueueSnackbar(
            length === 1
              ? 'A logística foi excluída com sucesso'
              : 'As logísticas foram excluídas com sucesso',
            {
              variant: 'success',
            },
          );
        })
        .catch(() => {
          reject(false);
          enqueueSnackbar(
            length === 1
              ? 'Houve uma falha ao excluir a logística'
              : 'Houve uma falha ao excluir as logísticas',
            {
              variant: 'error',
            },
          );
        })
        .finally(() => {
          setDeleteLogisticOriginLoadings(
            logisticOrigins.map((_, i) =>
              indexes.includes(i) ? false : deleteLogisticOriginLoadings[i],
            ),
          );
        });
    });


  const editLogistic = ({
    id,
    quantityVolume,
    nrcInvoiceNumber,
    clientInvoiceNumber,
    crt,
    clientName,
    warehouseDispatchDate,
    revenueDate,
    customsDate,
    storageDate,
    clientDate,
    releaseDate,
    observation,
    company,
    group,
  }: Logistic) => {
    setModal('single.updateLogistic', true);
    setInvoice('forms.logistics.update', {
      id,
      quantityVolume: quantityVolume ?? 0,
      nrcInvoiceNumber: nrcInvoiceNumber ?? '',
      clientInvoiceNumber: clientInvoiceNumber ?? '',
      crt: crt ?? '',
      clientName: clientName ?? '',
      warehouseDispatchDate: warehouseDispatchDate ?? '',
      revenueDate: revenueDate ?? '',
      customsDate: customsDate ?? '',
      storageDate: storageDate ?? '',
      clientDate: clientDate ?? '',
      releaseDate: releaseDate ?? '',
      observation: observation ?? '',
      company: {
        id: company.id,
        name: company.name,
      },
      group: {
        id: group?.id ?? 0,
        number: group?.number ?? 0,
        name: group?.name ?? ''
      },
    });
  };

  const editLogisticOrigin = ({
    id,
    originInvoiceNumber,
    quantityVolume,
    releaseDate,
    company,
    group,
  }: LogisticOrigin) => {
    setModal('single.updateLogisticOrigin', true);
    setInvoice('forms.logisticOrigins.update', {
      id,
      originInvoiceNumber: originInvoiceNumber ?? '',
      quantityVolume: quantityVolume ?? 0,
      releaseDate: releaseDate ?? '',
      company: {
        id: company.id,
        name: company.name,
      },
      group: {
        id: group?.id ?? 0,
        number: group?.number ?? 0,
        name: group?.name ?? ''
      },
    });
  };

  const logisticSearchFilter = getInvoice('filters.logistics.filter');

  const logisticOriginSearchFilter = getInvoice('filters.logisticOrigins.filter');

  const setLogisticSearchFilter = (filter: SearchFilter) =>
    setInvoice('filters.logistics.filter', filter);

  const setLogisticOriginSearchFilter = (filter: SearchFilter) =>
    setInvoice('filters.logisticOrigins.filter', filter);

  const getLogisticFilterField = (field: string, operator?: OPERATOR) =>
    getFilterColumn(field, logisticSearchFilter, operator);

  const getLogisticOriginFilterField = (field: string, operator?: OPERATOR) =>
    getFilterColumn(field, logisticOriginSearchFilter, operator);

  const setLogisticFilterField = (field: string, operator?: OPERATOR) => (e) => {
    let filter = setFilterColumn(field, e.target.value, logisticSearchFilter, operator);
    setLogisticSearchFilter({
      ...filter,
      page: 1,
    });
  };

  const setLogisticOriginFilterField = (field: string, operator?: OPERATOR) => (e) => {
    let filter = setFilterColumn(field, e.target.value, logisticOriginSearchFilter, operator);
    setLogisticOriginSearchFilter({
      ...filter,
      page: 1,
    });
  };

  const getLogisticSortField = (field: string) => getSortColumn(field, logisticSearchFilter);
  const getLogisticOriginSortField = (field: string) => getSortColumn(field, logisticOriginSearchFilter);
  const setLogisticSortField = (field: string) => (value) =>
    setLogisticSearchFilter(setSortColumn(field, value, logisticSearchFilter));
  const setLogisticOriginSortField = (field: string) => (value) =>
    setLogisticOriginSearchFilter(setSortColumn(field, value, logisticOriginSearchFilter));

  const getLogisticAutocompleteItems = <
    T extends keyof InvoiceState['autocompletes']['logistics'],
  >(
    field: T,
  ) =>
    getInvoice(`autocompletes.logistics.${field}.data`).map((name, id) => ({
      id,
      name,
    }));

  const getLogisticOriginAutocompleteItems = <
    T extends keyof InvoiceState['autocompletes']['logisticOrigins'],
  >(
    field: T,
  ) =>
    getInvoice(`autocompletes.logisticOrigins.${field}.data`).map((name, id) => ({
      id,
      name,
    }));

  const setLogisticAutocompleteItems = (
    field: keyof InvoiceState['autocompletes']['logistics'],
  ) => {
    return autocompleteLogistic(field);
  };

  const setLogisticOriginAutocompleteItems = (
    field: keyof InvoiceState['autocompletes']['logisticOrigins'],
  ) => {
    return autocompleteLogisticOrigin(field);
  };

  const setLogisticAutocompleteFilterField =
    (field: keyof InvoiceState['autocompletes']['logistics']) => (e) => {
      setInvoice(`autocompletes.logistics.${field}.filter.value`, e.target.value);
    };

  const setLogisticOriginAutocompleteFilterField =
    (field: keyof InvoiceState['autocompletes']['logisticOrigins']) => (e) => {
      setInvoice(`autocompletes.logisticOrigins.${field}.filter.value`, e.target.value);
    };


  const setLogisticField = (field: any, operator?: OPERATOR) => (e) => {
    setLogisticFilterField(field, operator)(e);
    setLogisticAutocompleteFilterField(field)(e);
  };

  const setLogisticOriginField = (field: any, operator?: OPERATOR) => (e) => {
    setLogisticOriginFilterField(field, operator)(e);
    setLogisticOriginAutocompleteFilterField(field)(e);
  };

  const onLogisticLineClickHandler = (index: number) => (e) => {
    var senderElementName = e.target.tagName.toLowerCase();
    if (['input', 'image', 'svg', 'path', 'button'].includes(senderElementName))
      return;
    const logisticId = logistics[index].id;
    checkLogisticId(logisticId);
  };

  const onLogisticOriginLineClickHandler = (index: number) => (e) => {
    var senderElementName = e.target.tagName.toLowerCase();
    if (['input', 'image', 'svg', 'path', 'button'].includes(senderElementName))
      return;
    const logisticOriginId = logisticOrigins[index].id;
    checkLogisticOriginId(logisticOriginId);
  };

  const hasCheckedLogistics = checkLogisticIds.length > 0;
  const hasCheckedLogisticOrigins = checkLogisticOriginIds.length > 0;
  const hasLogisticFilters = (logisticSearchFilter.filter?.length ?? 0) > 0;
  const clearLogisticAll = () => {
    setInvoice('filters.logistics.filter', {
      ...getInvoice('filters.logistics.filter'),
      filter: [],
      orderBy: [],
      page: 1,
    });
    setInvoice('selecteds.logistics', []);
    setInvoice('filters.logisticOrigins.filter', {
      ...getInvoice('filters.logisticOrigins.filter'),
      filter: [],
      orderBy: [],
      page: 1,
    });
    setInvoice('selecteds.logisticOrigins', []);
  };
  const LogisticControls = () => {
    return currentRoute.includes('/tools/exports/logistic') ? (
      <>
        <Can I="create" a="Logistic">
          {() => (
            <div style={{
              display: "flex"
            }}>
              <ButtonHeader
                className="button-header"
                onClick={() => {
                  setModal('single.createLogistic', true);
                }}
              >
                <div
                  style={{
                    marginRight: '20px',
                  }}
                >
                  <SVG.Icon.Plus fill="#364856" />
                </div>
                NOVA LOGÍSTICA
              </ButtonHeader>
              <ButtonHeader
                className="button-header"
                style={{
                  width: '300px',
                }}
                onClick={() => {
                  setModal('single.createLogisticOrigin', true);
                }}
              >
                <div
                  style={{
                    marginRight: '20px',
                  }}
                >
                  <SVG.Icon.Plus fill="#364856" />
                </div>
                NOVA LOGÍSTICA ORIGEM
              </ButtonHeader>
            </div>
          )}
        </Can>
        <ControlContainer>
          <Can I="delete" a="Logistic">
            {() => (
              <Control
                active={hasCheckedLogistics || hasCheckedLogisticOrigins}
                disabled={!(hasCheckedLogistics || hasCheckedLogisticOrigins)}
                onClick={() => {
                  setModal('single.deleteLogistics', true);
                }}
              >
                <SVG.Icon.Trash
                  color={hasCheckedLogistics || hasCheckedLogisticOrigins ? '#364856' : '#a7a7a7'}
                  width={24}
                  height={24}
                />
              </Control>
            )}
          </Can>

          <Control onClick={clearLogisticAll}>
            <SVG.Icon.SVGIconGrayBroom color="#364856" width={24} height={24} />
          </Control>
          <Control
            onClick={() => {
              setModal('single.filterLogistic', true);
            }}
          >
            <SVG.Icon.Filter width={24} height={24} borderOnly={!hasLogisticFilters} />
          </Control>
        </ControlContainer>
      </>
    ) : null;
  };
  const logisticTotal = getInvoice('filters.logistics.data.meta.total');
  const logisticCurrentPage = logisticSearchFilter.page ?? 1;
  const logisticItemsPerPage = logisticSearchFilter.limit ?? 0;
  const setLogisticPage = (page: number) =>
    setLogisticSearchFilter({
      ...logisticSearchFilter,
      page,
    });

  const setLogisticItemsPerPage = (limit: number) =>
    setLogisticSearchFilter({
      ...logisticSearchFilter,
      page: 1,
      limit,
    });
  const LogisticTableControl = () => {
    return (
      <Table.Control
        currentPage={logisticCurrentPage}
        itemsPerPage={logisticItemsPerPage}
        totalOfItems={logisticTotal}
        setPage={setLogisticPage}
        setItemsPerPage={setLogisticItemsPerPage}
      />
    );
  };

  const logisticOriginTotal = getInvoice('filters.logisticOrigins.data.meta.total');
  const logisticOriginCurrentPage = logisticOriginSearchFilter.page ?? 1;
  const logisticOriginItemsPerPage = logisticOriginSearchFilter.limit ?? 0;
  const setLogisticOriginPage = (page: number) =>
    setLogisticOriginSearchFilter({
      ...logisticOriginSearchFilter,
      page,
    });

  const setLogisticOriginItemsPerPage = (limit: number) =>
    setLogisticOriginSearchFilter({
      ...logisticOriginSearchFilter,
      page: 1,
      limit,
    });

  const LogisticOriginTableControl = () => {
    return (
      <Table.Control
        currentPage={logisticOriginCurrentPage}
        itemsPerPage={logisticOriginItemsPerPage}
        totalOfItems={logisticOriginTotal}
        setPage={setLogisticOriginPage}
        setItemsPerPage={setLogisticOriginItemsPerPage}
      />
    );
  };
  const [tableWidth, setTableWidth] = useState(730);

  const logisticGroups = groups.logistic;

  const logisticGroupItems = logisticGroups.map((group) => ({
    id: group.id,
    name: `${group.number} - ${group.name}`,
    data: group,
  }));

  return {
    logistics,
    logisticOrigins,
    checkLogisticIds,
    checkLogisticOriginIds,
    setCheckLogisticIds,
    setCheckLogisticOriginIds,
    reportLogistic,
    reportLogisticOrigin,
    allLogisticChecks,
    allLogisticOriginChecks,
    logisticCheckAll,
    logisticOriginCheckAll,
    checkLogisticId,
    checkLogisticOriginId,
    deleteLogistics,
    deleteLogisticOrigins,
    deleteLogisticLoadings,
    deleteLogisticOriginLoadings,
    LogisticControls,
    editLogistic,
    editLogisticOrigin,
    logisticSearchFilter,
    logisticOriginSearchFilter,
    setLogisticSearchFilter,
    setLogisticOriginSearchFilter,
    getLogisticFilterField,
    getLogisticOriginFilterField,
    setLogisticFilterField,
    setLogisticOriginFilterField,
    getLogisticSortField,
    getLogisticOriginSortField,
    setLogisticSortField,
    setLogisticOriginSortField,
    getLogisticAutocompleteItems,
    getLogisticOriginAutocompleteItems,
    setLogisticAutocompleteItems,
    setLogisticOriginAutocompleteItems,
    setLogisticAutocompleteFilterField,
    setLogisticOriginAutocompleteFilterField,
    setLogisticField,
    setLogisticOriginField,
    onLogisticLineClickHandler,
    onLogisticOriginLineClickHandler,
    filterLogistic,
    filterLogisticOrigin,
    setInvoice,
    LogisticTableControl,
    LogisticOriginTableControl,
    getFormMessage,
    createLogistic,
    createLogisticOrigin,
    updateLogistic,
    updateLogisticOrigin,
    getInvoice,
    setModal,
    validateForm,
    filterSelectCompanies,
    selectCompanies,
    setCompanyFilterField,
    tableWidth,
    setTableWidth,
    filterGroupLogistic,
    groups,
    logisticGroupItems,
    user,
    logisticGroups,
    selectedGroupId,
  };
};

export default useLogisticsController;
